
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Select from 'react-select';
import ApiService from '../../../INVENTORY/services/apiService';
import '../../../POS/component/pages/menus/addItems/addmenu.css'
import { FaAngleLeft } from "react-icons/fa6";
import Modal from 'react-bootstrap/Modal';
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL

const ItemMasterView = (props) => {
    const location = useLocation();
    const item = location.state;
    const [DirectPurchase, setDirectPurchase] = useState(false);
    const [FinishGood, setFinishGoods] = useState(false);
    const [Service, setService] = useState(false);
    const [loading, setLoading] = useState(false);

    const [ItemCode, setItemCode] = useState()
    const [itemDetais, setItemDetais] = useState(true);
    const [glDetails, setglDetails] = useState(false);
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);
    const handleClose = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [formData, setFormData] = useState({
        itemNo: '',
        recordId: '',
        Vat: [],
        volume: '',
        length: "",
        width: "",
        description: "",
        PackingUnitMeasurement: [],
        InventoryUom: [],
        Supplier: [],
        PackingType: [],
        height: "",
        fixedAsset: "",
        purchasePrice: 0,
        area: "",
        address: "",
        weight: "",
        Category: [],
        SubCategory: [],
        StockType: [],
        enableLoyalty: true,
        adjustmentAccount: "",
        grnAccount: "",
        cgsAccount: "",
        wastageAccount: "",
        InventoryAccounts: "",
        address02: "",
        status: true,
        creationDate: "",
        size: '',
        shape: '',
        reorderLevel: "",
        salePrice: 0,
        minLevel: 0,
        thickness: 0,
        maxLevel: 0,
        convToInvUOM: '',
        remarks: ''
    })

    useEffect(() => {
        const item = location.state;
        const setData = async () => {
            try {
                const apiService = new ApiService();
                setLoading(true)
                const SupplierRes = await apiService.get("GET_SUPPLIER_KANOO");
                const categoryResponse = await apiService.get("GET_CATEGORY");
                const selectedCategory = categoryResponse?.data?.result?.find(cat => cat?.catCode === item?.category);
                let param = `?isActive=true&Catcode=${selectedCategory?.catCode}`
                const subCategoryResponse = await apiService.getApiParamater("GET_SUB_CATEGORY", param);
                let glparam = `?ItemNo=${item?.itemNo}`
                const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", glparam);
                setService(item?.inventory === "True" ? false : true)
                setItemCode(item?.itemNo)
                let attachparam = `?DocNo=${item?.itemNo}&DocType=${"Item Master"}`
                const AttachmentResponse = await apiService.getApiParamater("GET_ATTACHMENT", attachparam);
                setAttachmentList(AttachmentResponse?.data?.result || [{ id: Date.now(), fileName: '', remarks: '' }])
                let itemGl = getGLAccounts?.data?.result[0]
                const selectedSuplier = SupplierRes?.data?.result?.find(sp => sp?.supplier_ID === item?.supplier);
                const selectedSuplierName = SupplierRes?.data?.result?.find(sp => sp?.supplierName === item?.supplier);
                const selectedSubCategory = subCategoryResponse.data.result?.find(cat => cat?.subcatcode === item?.subCategory);
                let selectedInvntory = null;
                let selectedAdjustmentAccount = null;
                let selectedgrnAccount = null;
                let selectedcgsAccount = null;
                let selectedwastageAccount = null;
                if (itemGl?.inventoryAccountCode) {
                    selectedInvntory = itemGl?.inventoryAccountName;
                }
                if (itemGl?.adjustmentAccountCode) {
                    selectedAdjustmentAccount = itemGl?.adjustmentAccountName;
                }
                if (itemGl?.grnAccountCode) {
                    selectedgrnAccount = itemGl?.grnAccountName;
                }
                if (itemGl?.cgsAccountCode) {
                    selectedcgsAccount = itemGl?.cgsAccountName;
                }
                if (itemGl?.wastageAccountCode) {
                    selectedwastageAccount = itemGl?.wastageAccountName;
                }
                setFormData({
                    Supplier: selectedSuplier?.supplierName || selectedSuplierName?.supplierName,
                    Category: selectedCategory?.catName,
                    SubCategory: selectedSubCategory?.subcatname,
                    adjustmentAccount: { label: selectedAdjustmentAccount, value: selectedAdjustmentAccount },
                    grnAccount: { label: selectedgrnAccount, value: selectedgrnAccount },
                    cgsAccount: { label: selectedcgsAccount, value: selectedcgsAccount },
                    wastageAccount: { label: selectedwastageAccount, value: selectedwastageAccount },
                    InventoryAccounts: { label: selectedInvntory, value: selectedInvntory },
                });

            } catch (error) {
                setLoading(false)
                console.error('Error:', error);
            }
            setLoading(false)
        }
        if (item) {
            setData()
        }
    }, [location?.state]);

    const handleBackClick = () => {
        window.history.back();
    };
    const handleView = (file) => {
        if (file) {
            setPreviewImage(file);
            setPreviewModal(true);
        } else {
            console.error("No valid file to preview");
        }
    };
    return (
        <div className='p-5'>
            <div className='d-flex justify-contant-between '>
                <h5 className='col mainInvHead'>Item Details</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className=''>
                <form class="row g-3 needs-validation" novalidate>
                    <div className="cost-center-section mb-2">
                        <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                            onClick={() => setItemDetais(!itemDetais)}>
                            <div className='h6 pt-1'>Item Detais</div>
                        </div>
                        <div className={`slide-content ${itemDetais ? 'open' : 'closed'}`}>
                            <div className="border-box2 p-3">
                                {loading && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            background: 'rgba(255,255,255,0.6)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 10,
                                        }}
                                    >
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                )}
                                <div className="form-group justify-content-between row pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom01" className="form-label  pt-1 start">Item No </label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.itemNo}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="vat" className="form-label  pt-1 start">VAT *</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.vat}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom15" className="form-label  pt-1 start">Volume</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.volume}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom02" className="form-label  pt-1 start">Length</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.length}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom07" className="form-label  pt-1 start">Description *</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.itemDescription}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">Inventory UOM *</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.unitMeasurement}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Thickness</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.thickness}
                                        />
                                    </div>
                                    <div className="col-3   d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Height</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.height}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Supplier
                                        </label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            disabled
                                            value={formData?.Supplier}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Packing type *
                                        </label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="packingType"
                                            disabled
                                            value={item?.packingType}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Reorder Level</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="reorderLevel"
                                            disabled
                                            value={item?.reorderLevel}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Size</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="size"
                                            disabled
                                            value={item?.size}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Category *
                                        </label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="Category"
                                            disabled
                                            value={formData?.Category}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            packing UOM *
                                        </label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="baseUnit"
                                            disabled
                                            value={item?.baseUnit}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Max QTY</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="maxLevel"
                                            disabled
                                            value={item?.maxLevel}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Shape</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="shape"
                                            disabled
                                            value={item?.shape}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Sub Category *
                                        </label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            disabled
                                            value={formData?.SubCategory}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Sale Price</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.salePrice || 0}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Min QTY</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.minLevel}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Weight</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.weight}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Stock Type *
                                        </label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            disabled
                                            value={item?.stockType}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Purchase Price</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.purchasePrice}
                                        />
                                    </div>
                                    <div className="col-3  d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Width</label>
                                        <input
                                            type="text"
                                            className="form-Input w-70"
                                            name="ItemCode"
                                            disabled
                                            value={item?.width}
                                        />
                                    </div>
                                    <div className='col-1'></div>
                                    <div className="col-2 brderbox center p-2" onClick={() => handleOpen()} >
                                        {'Attachment'}
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3  d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">
                                            {item?.baseUnit}{"   "}
                                            {item?.baseUnit ? '    =' : ''}
                                        </label>
                                        <input
                                            type='number'
                                            className="form-Input w-70"
                                            placeholder='Conversion Rate'
                                            disabled
                                            value={item?.convToInvUOM}
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <label htmlFor="validationCustom08" className="form-label pt-1 start">{item?.unitMeasurement}</label>
                                    </div>
                                    <div className="col-6 d-flex justify-content-between">
                                        <div className='gap-3 '>
                                            <div className="form-check">
                                                <input
                                                    style={{ width: "20px", height: "20px" }}
                                                    disabled
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={Service}
                                                    id="Service" name="Service"
                                                />
                                                <label className="form-check-label mx-2 mt-1">
                                                    Service
                                                </label>
                                            </div>
                                        </div>
                                        <div className='gap-3 '>
                                            <div className="form-check">
                                                <input
                                                    style={{ width: "20px", height: "20px" }}
                                                    disabled
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={item?.fixedAsset === "False" ? false : true}
                                                    id="Assest" name="Assest"
                                                />
                                                <label className="form-check-label mx-2 mt-1">
                                                    Fixed assets
                                                </label>
                                            </div>
                                        </div>
                                        <div className='gap-3 '>
                                            <div className="form-check">
                                                <input
                                                    style={{ width: "20px", height: "20px" }}
                                                    disabled
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={item?.exp9 === "1" ? true : false}
                                                    id="Active" name="Active"
                                                />
                                                <label className="form-check-label mx-2 mt-1">Active</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section">
                        <div className="d-flex cursor-pointer slide-header gap-4"
                            onClick={() => setglDetails(!glDetails)}>
                            <div className='h6 pt-1'>GL Accounts</div>
                        </div>
                        <div className={`slide-content ${glDetails ? 'open' : 'closed'}`}>
                            <div className="border-box2 p-3">
                                <div className='row'>
                                    <div className="col-lg-6">
                                        <div className="form-group row  pb-3">
                                            <div className="col-md-6 d-flex justify-content-between mb-3">
                                                <label htmlFor="validationCustom03" className="form-label pt-1 start">Inventory Account</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-70 p-0"
                                                    value={formData.InventoryAccounts}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                            <div className="col-md-6  d-flex justify-content-between mb-3">
                                                <label htmlFor="validationCustom04" className="form-label  pt-1 start">CGS</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-70 p-0"
                                                    value={formData.cgsAccount}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                            <div className="col-md-6 d-flex justify-content-between">
                                                <label htmlFor="validationCustom05" className="form-label  pt-1 start">Wastage Account</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-70 p-0"
                                                    value={formData.wastageAccount}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                            <div className="col-md-6 d-flex justify-content-between">
                                                <label htmlFor="validationCustom12" className="form-label  pt-1 start">GRN Account</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-70 p-0"
                                                    value={formData.grnAccount}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group d-flex gap-3 pb-3">
                                            <label htmlFor="validationCustom03" className="form-label  pt-1 start">Remarks</label>
                                            <input
                                                type="text"
                                                className="form-Input w-50"
                                                name="remarks"
                                                value={item?.remarks1}
                                                disabled
                                            />
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <div className="w-50 d-flex justify-content-between gap-3">
                                                <label htmlFor="validationCustom12" className="form-label  pt-1 start">Adjustment Account</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-70 p-0"
                                                    value={formData.adjustmentAccount}
                                                />
                                            </div>
                                            <div className='gap-3 pt-1'>
                                                <input className="form-check-input"
                                                    type="checkbox"
                                                    id="DirectPurchase" style={{ width: "20px", height: "20px" }}
                                                    name="DirectPurchase"
                                                    disabled
                                                    checked={DirectPurchase} />
                                                <label className='px-2 pt-1'>Direct Purchase</label>
                                            </div>
                                            <div className='gap-3 pt-1' >
                                                <input className="form-check-input"
                                                    type="checkbox"
                                                    id="FinishGood" style={{ width: "20px", height: "20px" }}
                                                    name="FinishGood"
                                                    checked={FinishGood}
                                                    disabled />
                                                <label className='px-2 pt-1'>Finish Good</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div>
                <Modal show={attachmentModal} size="lg" onHide={handleClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Attachments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col-3 d-flex justify-content-between">
                            <label htmlFor="docNp" className="form-label  pt-2 start">Document No</label>
                            <input disabled value={item?.itemNo} className="form-Input w-70" />
                        </div>
                        <div className="pt-2">
                            <table>
                                <thead className="dynoTable">
                                    <tr>
                                        <th>File Name</th>
                                        <th>Remarks</th>
                                        <th>Upload</th>
                                        <th>View</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachmentList?.map((attachment, index) => (
                                        <tr key={attachment.id}>
                                            <td className='m-0 p-0'><input className='p-0' type='text' disabled value={attachment.fileName} style={{ width: "320px" }} /></td>
                                            <td>
                                                <input type="text" value={attachment.remarks} disabled
                                                    style={{ width: '345px' }}
                                                />
                                            </td>
                                            <td>
                                                <button className='mainbtn ' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                                <input disabled
                                                    type="file" accept="image/*"
                                                    style={{ display: 'none' }}
                                                    id={`fileInput-${attachment.id}`}
                                                />
                                            </td>
                                            <td><button className='mainbtnRed ' onClick={() => handleView(attachment.fileName)} >
                                                <div>View</div></button></td>
                                            <td>
                                                <button disabled className='mainbtnSecondary'>
                                                    <div>Delete</div></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='mainbtn ' onClick={handleClose} >Attach</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {previewImage && <img src={IMAGE_URL + previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )
}
export default ItemMasterView